(() => {
  document.querySelectorAll('.mira-product__form').forEach((container) => {
    const select = container.querySelector('select[name="id"]');
    const price = container.closest('.mira-product__details')?.querySelector('[data-product-price]');
    const button = container.querySelector('[data-add-to-cart]');
    if (!select || !price || !button) return;
    const update = () => {
      const option = select.options[select.selectedIndex];
      price.textContent = option.dataset.variantPrice || price.textContent;
      const available = option.dataset.variantAvailable === 'true';
      button.disabled = !available;
      button.textContent = available ? 'Add to cart' : 'Sold out';
    };
    select.addEventListener('change', update);
    update();
  });
})();
